const ptBR = {
  apiErrors: {
    offline:
      'Conexão perdida. Seu rascunho não enviado continua aqui. Repita a mesma operação quando reconectar.',
    unauthorized: 'Sua sessão expirou. Entre novamente para continuar.',
    forbidden: 'Sua sessão atual não tem permissão para esta operação.',
    notFound: 'Este item está indisponível ou não está mais visível.',
    conflict: 'A versão mudou enquanto você editava. Nada foi sobrescrito.',
    tooLarge:
      'Esta alteração excede o limite do vault. Reduza o conteúdo e tente novamente.',
    rateLimited:
      'O vault está limitando requisições temporariamente. Preserve o rascunho e tente depois.',
    unavailable:
      'A escrita está temporariamente indisponível. Seu rascunho não foi publicado.',
    invalid: 'Confira os metadados, limites e campos obrigatórios.',
    reference: 'Referência da requisição: {{id}}',
  },
  session: {
    local: 'Sessão local de desenvolvimento',
    mock: 'Demonstração em memória',
    shared: 'Vault compartilhado',
    visitor: 'Visitante somente leitura',
    signIn: 'Entrar',
    signOut: 'Sair',
    localToken: 'Token da sessão local',
    localHelp:
      'Cole o token da configuração local do operador. Ele é trocado por um cookie HttpOnly e nunca é salvo no armazenamento do navegador.',
    readOnly: 'Vault somente leitura',
    role: 'Papel: {{role}}',
  },
  editor: {
    proposalId: 'ID da proposta',
    contentHash: 'Hash do conteúdo revisado (SHA-256)',
    types: {
      note: 'Nota',
      lesson: 'Lição',
      decision: 'Decisão',
      incident: 'Incidente',
      process: 'Processo',
      document: 'Documento',
    },
    loadedCount: '{{count}} documentos carregados; este ramo pode conter mais itens',
    versionConflict:
      'Sua versão base do documento: v{{base}}. Versão atual: v{{current}}.',
    proposalConflict:
      'Sua versão base da proposta: v{{base}}. Versão atual: v{{current}}.',
    metadataFields: {
      type: 'Tipo',
      folderId: 'Pasta',
      tags: 'Tags',
      relations: 'Referências',
      visibility: 'Visibilidade',
      status: 'Estado editorial',
      locale: 'Idioma',
    },
    summary: 'Resumo da proposta',
    metadata: 'Metadados do documento',
    documentTitle: 'Título do documento',
    visibility: 'Visibilidade',
    public: 'Público',
    internal: 'Interno',
    relations: 'IDs das referências',
    commaSeparated: 'Valores separados por vírgulas',
    operation: 'Operação da alteração',
    modify: 'Modificar documento',
    delete: 'Excluir documento (após merge)',
    editProposal: 'Editar proposta',
    resubmit: 'Salvar e reenviar',
    proposalVersion: 'Versão {{version}} da proposta',
    baseVersion: 'Baseado no documento v{{version}}.',
    confirmMerge: 'Confirmar merge',
    authorizeMerge: 'Autorizar merge',
    mergeExplanation:
      'Publicar “{{title}}”, versão {{version}} da proposta? Esta confirmação vale somente para a versão revisada.',
    webmcpMergeExplanation:
      'Autorize o agente a integrar “{{title}}”, versão {{version}} da proposta. Nada é publicado até que o agente repita explicitamente a mesma operação com a chave original.',
    mergeConfirmationExpiry:
      'Esta solicitação expira às {{expiresAt}}. Aceitar não publica; o agente precisa repetir esta operação exata.',
    conflictHelp:
      'Seu rascunho foi preservado. Abra o documento atual em outra aba, compare as versões e inicie outra proposta a partir dessa revisão. A versão base nunca é avançada silenciosamente.',
    unsent: 'Rascunho não enviado. As alterações aqui não estão salvas no vault.',
    saveLocal: 'Salvar rascunho neste dispositivo',
    restoreLocal: 'Restaurar rascunho local',
    savedLocally: 'Salvo somente neste dispositivo. Não enviado ao vault.',
    discard: 'Descartar este rascunho não enviado?',
    graphLimited: 'Grafo limitado. Reduza o escopo para explorar mais.',
    loadMore: 'Carregar mais',
    loadingFolder: 'Carregando pasta…',
  },
  brand: { subtitle: 'Conhecimento vivo' },
  nav: {
    atlas: 'Atlas',
    library: 'Biblioteca',
    docs: 'Docs',
    proposals: 'Propostas',
    history: 'Histórico',
  },
  shell: {
    openNavigation: 'Abrir navegação',
    closeNavigation: 'Fechar navegação',
    skip: 'Ir para o conteúdo',
    search: 'Buscar conhecimento',
    searchPlaceholder: 'Busque decisões, incidentes, lições…',
    newMemory: 'Nova memória',
    primaryNavigation: 'Navegação principal',
    vault: 'Vault',
    branch: 'ramo',
    synced: 'Vault sincronizado',
    momentsAgo: 'agora há pouco',
  },
  atlas: {
    kicker: 'Constelação de conhecimento',
    title: 'O mapa vivo',
    subtitle: 'Lições, decisões e discussões aceitas neste vault.',
    relatedTitle: 'Vizinhança de {{title}}',
    relatedSubtitle:
      'Referências diretas e backlinks ao redor do documento selecionado.',
    folderSubtitle:
      'O conhecimento da pasta permanece em foco enquanto relações externas aparecem.',
    related: 'Relacionados',
    folder: 'Pasta',
    entire: 'Vault inteiro',
    listView: 'Ver em lista',
    graphView: 'Ver grafo',
    legendKnowledge: 'Conhecimento',
    legendDecision: 'Decisão',
    legendIncident: 'Incidente',
    legendLabel: 'Legenda do grafo',
    graphLabel: 'Grafo de conhecimento',
    nodes: '{{count}} memórias',
    relations: '{{count}} relações',
    openNode: 'Abrir {{title}}',
    noGraph: 'Não há dados de grafo para este escopo.',
    external: 'Relação externa',
    interactionHint:
      'Selecione uma memória para revelar a vizinhança. Clique duas vezes para abrir.',
    selectedHint: 'Vizinhança destacada. Use a seta no nó para abrir.',
    selectNode: 'Selecionar {{title}}',
    galaxies: '{{count}} galáxias',
    bridges: '{{count}} pontes',
    hub: 'Núcleo de conhecimento',
    cameraControls: 'Controles da câmera',
    panMap: 'Mover mapa',
    rotateLeft: 'Girar à esquerda',
    rotateRight: 'Girar à direita',
    tiltUp: 'Inclinar para cima',
    tiltDown: 'Inclinar para baixo',
    zoomIn: 'Aproximar',
    zoomOut: 'Afastar',
    resetView: 'Restaurar vista',
    pauseMotion: 'Pausar movimento',
    reducedMotion: 'Movimento desativado pela preferência do sistema',
    resumeMotion: 'Retomar movimento',
    cameraHint: 'Arraste para girar · Direito/Shift + arraste move · Role para zoom',
    cameraPanHint:
      'Arraste para mover · Desative Mover mapa para girar · Role para zoom',
    cameraKeyboardHint: 'Setas giram · Shift + setas movem · Home restaura',
    canvasUnavailable:
      'A vista espacial está indisponível. Escolha Ver em lista para explorar todas as memórias.',
  },
  folders: {
    title: 'Pastas',
    all: 'Todo o conhecimento',
    collapse: 'Recolher {{name}}',
    expand: 'Expandir {{name}}',
    openFolder: 'Abrir {{name}}',
    documentCount_one: '{{count}} documento',
    documentCount_other: '{{count}} documentos',
    documents: '{{count}} documentos',
  },
  library: {
    kicker: 'Biblioteca Markdown',
    title: 'Todo o conhecimento',
    lead: 'Navegue pela fonte durável por trás da constelação. Cada documento continua sendo Markdown portátil.',
    reset: 'Todos os documentos',
    viewAtlas: 'Ver como constelação',
    search: 'Filtrar documentos',
    searchPlaceholder: 'Filtre por título, caminho, tag…',
    sort: 'Ordenar',
    sortUpdated: 'Atualizados recentemente',
    sortTitle: 'Título',
    sortKind: 'Tipo',
    list: 'Lista',
    cards: 'Cartões',
    view: 'Visualização',
    results: '{{count}} documentos',
    relationsCount: '{{count}} relações',
    emptyTitle: 'Nenhum documento corresponde aos filtros',
    emptyBody: 'Tente limpar a pasta ou o filtro de busca.',
    path: 'Caminho',
    type: 'Tipo',
    status: 'Status',
    author: 'Autor',
    updated: 'Atualizado',
    relations: 'Relações',
  },
  document: {
    preview: 'Prévia',
    markdown: 'Markdown',
    relations: 'Relações',
    history: 'Histórico',
    graph: 'Grafo',
    document: 'Documento',
    edit: 'Editar',
    cancel: 'Cancelar',
    propose: 'Propor alterações',
    proposeChanges: 'Propor alterações',
    copyLink: 'Copiar link',
    copied: 'Link de conhecimento copiado',
    contributors: 'Colaboradores',
    details: 'Detalhes',
    version: 'Versão',
    linksOut: 'Links de saída',
    backlinks: 'Backlinks',
    tags: 'Tags',
    noRelations: 'Ainda não há relações.',
    relationsLead: 'Siga os links que dão contexto a esta memória.',
    sourceNote:
      'Editando um rascunho de proposta. O conhecimento publicado só muda após o merge.',
    notFound: 'Documento não encontrado',
    backLibrary: 'Voltar à Biblioteca',
    openDocument: 'Abrir documento {{title}}',
    revision: 'Revisão {{version}}',
    currentVersion: 'Versão atual',
    created: 'Criado',
  },
  proposals: {
    kicker: 'Governança do vault',
    title: 'Propostas',
    lead: 'O conhecimento se torna oficial por meio de revisão visível — nunca por edições silenciosas.',
    all: 'Todas',
    open: 'Abertas',
    changesRequested: 'Alterações solicitadas',
    approved: 'Aprovadas',
    merged: 'Integradas',
    awaiting: '{{count}} aguardando resolução',
    emptyTitle: 'Nenhuma proposta neste estado',
    emptyBody: 'Escolha outro status ou volte para todas as propostas.',
    listLabel: 'Lista de propostas',
    detailLabel: 'Detalhe da proposta',
    detailPrompt:
      'Abra uma proposta para inspecionar verificações, discussão e o diff Markdown exato.',
    files: '{{count}} arquivos',
    checks: '{{passed}}/{{total}} verificações aprovadas',
    linksResolved: 'links resolvidos',
    formatValid: 'formato válido',
    approve: 'Aprovar',
    merge: 'Integrar ao vault',
    requestChanges: 'Solicitar alterações',
    mergeReason: 'O merge cria a próxima revisão publicada.',
    back: 'Voltar às propostas',
    affectedFiles: 'Arquivos afetados',
    reviewSummary: 'Resumo da revisão',
    openProposal: 'Abrir proposta #{{number}}',
    noSelection: 'Selecione uma proposta para revisar.',
    newProposal: 'Nova proposta',
    titleField: 'Título da proposta',
    reasonField: 'Nota de revisão',
    reasonPlaceholder: 'Explique a intenção ou as alterações necessárias…',
    noDiff: 'Nenhum diff textual está disponível.',
    newFile: 'Arquivo novo',
    pathUnavailable: 'Caminho indisponível',
    reviewQueue: 'Fila de revisão',
    queueSummary: '{{count}} propostas nesta visualização',
    queuePolicy: 'main · revisão obrigatória',
    newDocument: 'Documento novo',
    updatedBy: 'atualizada {{date}} por {{author}}',
    changeCount_one: '{{count}} arquivo alterado',
    changeCount_other: '{{count}} arquivos alterados',
  },
  history: {
    kicker: 'Trilha imutável',
    title: 'Histórico do vault',
    lead: 'Cada alteração aceita deixa uma trilha legível de quem mudou o quê, por quê e qual versão resultou.',
    export: 'Exportar log',
    versions: '{{branch}} · {{count}} versões',
    openEvent: 'Abrir evento {{title}}',
    proposal: 'Proposta',
    document: 'Documento',
    revision: 'Revisão',
    noEvents: 'Ainda não há eventos no histórico.',
    eventDetail: 'Evento do histórico',
    back: 'Voltar ao histórico',
    resultingRevision: 'Revisão resultante',
    publishedRevision: 'Publicado como revisão {{version}}.',
    immutable: 'Este evento faz parte da trilha imutável do vault.',
    searchPlaceholder: 'Busque ator, alteração ou documento…',
    eventType: 'Tipo de evento',
    eventTypes: {
      proposal: 'Proposta',
      publish: 'Publicação',
      restore: 'Restauração',
      relation: 'Relação',
      create: 'Criação',
    },
  },
  docs: {
    kicker: 'Docs do vault',
    title: 'Aprenda Lorestra',
    lead: 'A documentação do produto vive no mesmo vault revisável que o conhecimento de engenharia.',
    read: 'Ler guia',
    cookbook: 'Cookbook',
    whatIs: 'O que é Lorestra?',
    usage: 'Guia de uso',
    noDoc: 'Este documento não está disponível no idioma selecionado.',
    back: 'Voltar para Docs',
    contents: 'Conteúdo',
    agentReady: 'Conhecimento nativo em WebMCP',
    agentReadyBody:
      'Pessoas recebem um workspace bilíngue e tranquilo. Agentes ganham onze ferramentas tipadas para descoberta, leitura, grafo, propostas e histórico.',
  },
  common: {
    loading: 'Carregando…',
    retry: 'Tentar novamente',
    errorTitle: 'Algo deu errado',
    unknown: 'Desconhecido',
    justNow: 'Agora mesmo',
    locale: 'Idioma',
    close: 'Fechar',
    open: 'Abrir',
    clear: 'Limpar',
    selected: 'Selecionado',
    status: 'Status',
    search: 'Buscar',
    required: 'Este campo é obrigatório.',
    pagination: 'Paginação',
    paginationRange: '{{start}}–{{end}} de {{total}}',
    paginationTotal: '{{total}} no total',
    previous: 'Anterior',
    next: 'Próxima',
    published: 'Publicado',
    draft: 'Rascunho',
    archived: 'Arquivado',
    kind: {
      incident: 'Incidente',
      decision: 'Decisão',
      runbook: 'Runbook',
      guide: 'Guia',
      process: 'Processo',
      note: 'Nota',
      docs: 'Docs',
      folder: 'Pasta',
    },
  },
}

export default ptBR
